import { CategoryTypeEnum } from "./category-type.enum";

export class Category {
    constructor(
        public readonly id: CategoryTypeEnum,
        public readonly name: string,
    ) {}
}
